import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import useMoney from '../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { OrderError } from '../../../../edit/sections/OrderEditSections.types';
import OrderValidationErrorsTooltipContent from '../../../../edit/validate/components/OrderValidationErrorsTooltipContent';
import { isBusinessPolicyError } from '../../../../edit/validate/conditions/businessPolicy/businessPolicyViolation.utils';
import BusinessPolicyViolationSummary from '../../../../edit/validate/conditions/businessPolicy/components/BusinessPolicyViolationSummary';
import { useBusinessPolicyViolationViews } from '../../../../edit/validate/conditions/businessPolicy/hooks/useBusinessPolicyViolationViews';
import { getOrderErrorQuantity } from '../../../../edit/validate/utils/orderValidation.utils';

interface OrderConditionErrorsTooltipContentProps {
  errors: OrderError[];
  onOpenDetails?: () => void;
}

const OrderConditionErrorsTooltipContent = ({
  errors,
  onOpenDetails,
}: OrderConditionErrorsTooltipContentProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();
  const policyViolations = useBusinessPolicyViolationViews(errors);

  const registrationErrors = [
    ...new Set(
      errors
        .filter((error) => !isBusinessPolicyError(error))
        .map(({ messageCode, extra }) =>
          translate(messageCode, {
            quantity: getOrderErrorQuantity({
              extra: Array.isArray(extra) ? undefined : extra,
              formatMoney,
              key: 'quantity',
            }),
            expected: getOrderErrorQuantity({
              extra: Array.isArray(extra) ? undefined : extra,
              formatMoney,
              key: 'expected',
            }),
          }),
        ),
    ),
  ];

  return (
    <Stack sx={{ gap: 1.5, maxWidth: 400 }}>
      {!!registrationErrors.length && (
        <OrderValidationErrorsTooltipContent errors={registrationErrors} />
      )}

      {!!policyViolations.length && (
        <Stack sx={{ gap: 1 }}>
          <Typography variant="subtitle2" color="inherit">
            {translate(LangEnum.ORDER_VALIDATION_POLICY_PENDING)}
          </Typography>
          <BusinessPolicyViolationSummary
            violations={policyViolations}
            onOpenDetails={onOpenDetails}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default OrderConditionErrorsTooltipContent;
